import { useEffect, useState } from 'react';
import type { UserFilters, UserResponse } from 'stream-chat';
import { useChatContext } from 'stream-chat-react';
import { StreamChatAvatar } from './StreamChatAvatar';
import { useStreamChatContext } from '~/react_context/StreamChatContext';

type Props = {
	userFilter?: UserFilters;
} & (
	| {
			onUserDeselected: (user: UserResponse) => void;
			onUserSelected: (user: UserResponse) => void;
	  }
	| {
			onUserDeselected?: undefined;
			onUserSelected?: undefined;
	  }
);

export default function StreamChatUserSelectList({ onUserDeselected, onUserSelected, userFilter }: Props) {
	const { client } = useChatContext();
	const { businessTeamName } = useStreamChatContext();
	const [users, setUsers] = useState<UserResponse[]>();

	useEffect(() => {
		const sameTeamFilter: UserFilters = { teams: { $contains: businessTeamName } };
		const getUsers = async () => {
			// @ts-ignore $nin doesn't exist in the type definition but is supported
			const response = await client.queryUsers({ ...(userFilter ?? { id: { $nin: [client.userID!] } }), ...sameTeamFilter }, { name: 1 });
			setUsers(response.users);
		};
		void getUsers();
	}, [client]);

	return users === undefined ? (
		<>Loading users...</>
	) : (
		<ol className="flex flex-col gap-1">
			{users.length === 0 && <li>No users found</li>}
			{users.map((user) => (
				<li className="flex gap-2 items-center" key={user.id}>
					{onUserSelected && onUserDeselected && (
						<input
							type="checkbox"
							id={user.id}
							value={user.id}
							onChange={(e) => {
								if (e.target.checked) {
									onUserSelected(user);
								} else {
									onUserDeselected(user);
								}
							}}
						/>
					)}
					<label className="flex gap-2 items-center" htmlFor={user.id}>
						<StreamChatAvatar className="!h-8 !w-8" image={user.image} name={user.name || user.id} />
						{user.name || user.id}
					</label>
				</li>
			))}
		</ol>
	);
}
